// Import fonts as URLs so Vite processes them correctly
import gilroyExtraboldWoff2 from "./fonts/gilroy-extrabold-webfont.woff2?url";
import gilroyExtraboldWoff from "./fonts/gilroy-extrabold-webfont.woff?url";
import gilroyLightWoff2 from "./fonts/gilroy-light-webfont.woff2?url";
import gilroyLightWoff from "./fonts/gilroy-light-webfont.woff?url";

// Convert relative URLs to absolute with proper Vite dev server origin
const baseUrl = import.meta.env.DEV ? 'https://indieep.test:5173' : '';
const toAbsoluteUrl = (path: string) => path.startsWith('/') ? `${baseUrl}${path}` : path;

const fontUrls = {
  gilroyExtraboldWoff2: toAbsoluteUrl(gilroyExtraboldWoff2),
  gilroyExtraboldWoff: toAbsoluteUrl(gilroyExtraboldWoff),
  gilroyLightWoff2: toAbsoluteUrl(gilroyLightWoff2),
  gilroyLightWoff: toAbsoluteUrl(gilroyLightWoff)
};

// Create stylesheet with proper URLs
const style = document.createElement('style');
style.textContent = `
  @font-face {
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 700;
    src:
      url("${fontUrls.gilroyExtraboldWoff2}") format("woff2"),
      url("${fontUrls.gilroyExtraboldWoff}") format("woff");
  }

  @font-face {
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 400;
    src:
      url("${fontUrls.gilroyLightWoff2}") format("woff2"),
      url("${fontUrls.gilroyLightWoff}") format("woff");
  }
`;
document.head.appendChild(style);
